import ModuleMarginWrapper from "theme/components/wrappers/ModuleMarginWrapper";
import PropTypes from "prop-types";
import React from "react";
import YouTubePlayerBlock from "theme/libs/wordpress/content/cmsBlocks/YouTubePlayerBlock";

const YouTubePlayerModule = ({ content }) => (
    <ModuleMarginWrapper
        // marginAfter="lg"
        marginAfter="none"
    >
        <YouTubePlayerBlock content={content} />
    </ModuleMarginWrapper>
);

YouTubePlayerModule.propTypes = {
    content: PropTypes.object,
};

YouTubePlayerModule.defaultProps = {
    content: undefined,
};

export default YouTubePlayerModule;
